// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatMarkdownTable-moduletable__gl7aV";
var _2 = "GretaAIChatMarkdownTable-moduletableWrapper__OERrd";
export { _1 as "table", _2 as "tableWrapper" }
